import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type PopupProps = {
  show: boolean;
  title?: string;
  onClose: () => void;
  ContentComponent: React.ElementType;
  contentProps?: Record<string, any>;
  width?: "xs" | "sm" | "md" | "lg" | "xl";
  wrapContent: boolean;
};

const Popup: React.FC<PopupProps> = ({
  show,
  title,
  onClose,
  ContentComponent,
  contentProps = {},
  width = "lg",
  wrapContent = true,
}) => {
  const theme = useTheme();

  if (!show) return null;

  const content = <ContentComponent {...contentProps} />;

  return (
    <Dialog open={show} onClose={onClose} fullWidth maxWidth={width}>
      {title && title?.length > 0 && (
        <DialogTitle
          sx={{ borderBottom: "1px solid " + theme.palette.divider }}
        >
          {title}
        </DialogTitle>
      )}

      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 10,
          top: 10,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      {wrapContent ? <DialogContent>{content}</DialogContent> : content}
    </Dialog>
  );
};

export default Popup;
